// extracted by mini-css-extract-plugin
export default {"container":"style_container__-px4l","hambergur":"style_hambergur__cLkXs","profile":"style_profile__dC0Ai","profile_avatar":"style_profile_avatar__PxUSE"};